import { Request,BaseApiUrl } from "./api";

// 未完成列表
export const getWeighingOutListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingOut/get`, { params: params });
};
// 获取所有列表
export const getWeighingOutHistryListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingOut/Histry`, { params: params });
};

//获取磅秤信息
  export const getWhsettingDetail = (params) => {
    return Request.get(`${BaseApiUrl}/api/Whsetting/GetWhsetting`, { params: params });
  };
//新增
export const addWeighingOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingOut/Post`, params);
};
//编辑
export const editWeighingOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingOut/Put`, params);
};
//完成
export const completeWeighingOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingOut/Complete`, params);
};
//作废
export const cancelWeighingOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingOut/Cancel`, params);
};
//批量删除
export const batchDeleteWeighingOut = (params) => {
  return Request.post(`${BaseApiUrl}/api/WeighingOut/BatchDelete`, params);
};
//获取车牌号
export const getOutMasterHistry = (params) => {
  return Request.get(`${BaseApiUrl}/api/Command/GetOutMasterHistry`, { params: params });
};
//获取打印详情
export const getPrintContent = (params) => {
  return Request.get(`${BaseApiUrl}/api/WeighingOut/Print`, { params: params });
};
//过皮
export const setWeight = (params) => {
  return Request.post(`${BaseApiUrl}/api/Vehicle/SetWeight`, params);
};